declare global {
  interface Window {
    allConsentGranted?: () => void;
    dataLayer?: any[];
  }
}

export const sendGTMEvent = (data: object) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

export const updateGTMConsent = () => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.allConsentGranted === 'function') {
    window.allConsentGranted();

    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'allConsentGranted' });
};
